import {cx} from "@emotion/css";

import {designColors} from "~/ui";
import {ReactComponent as SvgShippingLabel} from "~/assets/svg/shipping-label.svg";

import {simpleIconStyles} from "../styles";
import {commonStyles} from "../../_common/styles";
import {IIconBase} from "../../_common/types";

export const BmShippingLabelIcon: React.FC<IIconBase> = ({id, size = "sm", color = designColors.black, className}) => {
  return <SvgShippingLabel id={id} className={cx(simpleIconStyles(size), commonStyles.color(color), className)} />;
};
